import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { useState } from 'react';
export function getUniqueId() {
  return Math.random().toString(16).slice(2);
}
function useUniqueId(customId) {
  var _useState = useState(getUniqueId),
    _useState2 = _slicedToArray(_useState, 1),
    uniqueId = _useState2[0];
  return customId || uniqueId;
}
export default useUniqueId;